import humanFormat from "human-format";

export const toPeopleCount = (number: number) => {
  if (number < 10_000) return number.toLocaleString();
  const result = humanFormat.raw(number, { maxDecimals: 1 });
  return `${result.value}${result.prefix.toUpperCase()}`;
};
